import { ISelectOption } from "src/app/interfaces/components/select.interface";

export const granularityOptions: ISelectOption[] = [
  { label: 'DASHBOARD.FILTERS.GRANULARITY.DAY', value: 'Day' },
  { label: 'DASHBOARD.FILTERS.GRANULARITY.WEEK', value: 'Week' },
  { label: 'DASHBOARD.FILTERS.GRANULARITY.MONTH', value: 'Month' },
];
